export default __webpack_public_path__ + "static/531-a2fda3b2e47c08f0cb01e4ba1eabfe2a.gif";